export default function displayTvl(dollarValue: bigint): string {
  const numericValue = Number(dollarValue);

  if (numericValue > 1000000) {
    const valueInMillions = (numericValue / 1000000).toFixed(1);
    return `$${valueInMillions} M`;
  } else if (numericValue > 1000) {
    const valueInThousands = (numericValue / 1000).toFixed(1);
    return `$${valueInThousands} K`;
  } else {
    return `$${numericValue.toString()}`;
  }
}
